import { useEffect, useRef, useState } from "react";
import { api, BACKEND_URL } from "./api";

export const media = (u) => (u && u.startsWith("/api/") ? `${BACKEND_URL}${u}` : u);

export const KIND_LABEL = { couple: "Couple", planner: "Planner", venue: "Venue", vendor: "Vendor", creator: "Creator", guest: "Wedding guest" };

export function fileToDataUrl(file, maxMb = 10) {
  return new Promise((resolve, reject) => {
    if (file.size > maxMb * 1024 * 1024) return reject(new Error(`Max ${maxMb}MB per image`));
    const r = new FileReader();
    r.onload = () => resolve(r.result);
    r.onerror = reject;
    r.readAsDataURL(file);
  });
}

// One authenticated socket per hook user; reconnects with backoff.
export function useDmSocket(enabled, onEvent) {
  const cb = useRef(onEvent);
  cb.current = onEvent;
  useEffect(() => {
    if (!enabled) return;
    let ws, stop = false, retry = 1000, ping;
    const url = `${BACKEND_URL.replace(/^http/, "ws")}/api/ws/dm`;
    const open = () => {
      ws = new WebSocket(url);
      ws.onopen = () => { retry = 1000; ping = setInterval(() => ws.readyState === 1 && ws.send("ping"), 25000); };
      ws.onmessage = (e) => { if (e.data !== "pong") { try { cb.current(JSON.parse(e.data)); } catch (_) { /* ignore */ } } };
      ws.onclose = () => { clearInterval(ping); if (!stop) setTimeout(open, (retry = Math.min(retry * 2, 15000))); };
    };
    open();
    return () => { stop = true; clearInterval(ping); ws && ws.close(); };
  }, [enabled]);
}

export function useUnread(user) {
  const [n, setN] = useState(0);
  useEffect(() => {
    if (!user) { setN(0); return; }
    const load = () => api.get("/dm/unread").then((r) => setN(r.data.total)).catch(() => {});
    load();
    const t = setInterval(load, 60000);
    window.addEventListener("lif:unread", load);
    return () => { clearInterval(t); window.removeEventListener("lif:unread", load); };
  }, [user]);
  useDmSocket(!!user, (ev) => { if (ev.type === "unread") setN(ev.total); });
  return n;
}
